/**
 * Mobile layout of the Certification & Compliance, ESG and Ryerson Gives Back teasers: a
 * pass-through to `../ProductQuality/ProductQualityMobile.tsx`, so on mobile these three look like
 * the other commitment teasers.
 */
import React from "react";
import { CertificateAndComplianceProps } from "./CertificateAndCompliance";
import ProductQualityMobile from "../ProductQuality/ProductQualityMobile";

/** Renders `ProductQualityMobile` with the same props. */
const CertificateAndComplianceMobile: React.FC<CertificateAndComplianceProps> = ({ ...props }) => {
	return <ProductQualityMobile {...props} />;
};

export default CertificateAndComplianceMobile;
